import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

import styles from './RouteErrorBoundary.module.scss';

export function RouteErrorBoundary() {
    const error = useRouteError();
    const navigate = useNavigate();
    const notFound = isRouteErrorResponse(error) && error.status === 404;

    return (
        <div className={styles['wrap']} role="alert">
            <img className={styles['logo']} src="/assets/reveal-logo-white.png" alt="Reveal" />
            <h1 className={styles['title']}>{notFound ? 'Page not found' : 'Something went wrong'}</h1>
            <p className={styles['message']}>
                {notFound
                    ? 'That screen does not exist. Functionality forthcoming.'
                    : 'This screen hit an unexpected error. Functionality forthcoming.'}
            </p>
            <div className={styles['actions']}>
                <button type="button" className={styles['primary']} onClick={() => navigate(-1)}>
                    Go back
                </button>
                <button
                    type="button"
                    className={styles['secondary']}
                    onClick={() => globalThis.location.reload()}
                >
                    Reload
                </button>
            </div>
        </div>
    );
}
